export interface TextHashes {
  sha256: string
  sha1: string
  md5: string
}

function toHex(buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer), (byte) => byte.toString(16).padStart(2, '0')).join('')
}

export async function generateTextHashes(text: string): Promise<TextHashes> {
  const bytes = new TextEncoder().encode(text)
  const [{ default: SparkMD5 }, sha256, sha1] = await Promise.all([
    import('spark-md5'),
    crypto.subtle.digest('SHA-256', bytes),
    crypto.subtle.digest('SHA-1', bytes),
  ])

  return {
    sha256: toHex(sha256),
    sha1: toHex(sha1),
    md5: SparkMD5.ArrayBuffer.hash(bytes.buffer),
  }
}
